import { BRAND } from '../config';
import { DomumMark } from './DomumMark';

/** Знак VIA DOMUM + словесний знак (Forum, 0.22em) з підписом між лініями. */
export function Logo({ caption }: { caption: string }) {
  return (
    <span className="inline-flex w-max items-end gap-2.5">
      <DomumMark className="h-9 w-7 shrink-0" />
      <span className="inline-flex flex-col gap-2">
        <b className="font-wordmark text-[20px] font-normal leading-none sm:text-[24px]" style={{ letterSpacing: '.22em', marginRight: '-.22em' }}>
          {BRAND.toUpperCase()}
        </b>
        <i
          className="flex items-center gap-2 text-[9px] font-normal not-italic leading-none text-lab before:h-[2px] before:flex-1 before:bg-lab before:opacity-80 before:content-[''] after:h-[2px] after:flex-1 after:bg-lab after:opacity-80 after:content-['']"
          style={{ letterSpacing: '.36em', paddingLeft: '.36em' }}
        >
          {caption.toUpperCase()}
        </i>
      </span>
    </span>
  );
}
